/**
 * FeedbackBanner — belka (announcement bar) dla ZALOGOWANYCH, którzy nie dali jeszcze
 * feedbacku. Reklamuje darmowe kredyty za ankietę; klik otwiera FeedbackInvitePrompt
 * (ten sam formularz co auto-trigger po N generacjach — nie dublujemy modala).
 *
 * Widoczna do momentu wypełnienia (brak "dismiss"). Źródło prawdy: /v1/feedback/check,
 * współdzielony cache TanStack pod kluczem ["feedback-given", userId] — po submicie
 * FeedbackInvitePrompt invaliduje ten klucz i belka znika sama.
 *
 * Niezweryfikowany e-mail → EmailVerificationBanner ma priorytet, belka ukryta.
 */
import { useQuery } from "@tanstack/react-query";
import { Icon } from "@/components/ui/Icon";
import { useAuth } from "@/hooks/useAuth";
import { getFeedbackConfig, checkFeedbackGiven } from "@/lib/apiClient";

export function FeedbackBanner({ onOpen }: { onOpen: () => void }) {
  const { user, isLoading: authLoading } = useAuth();
  const emailVerified = user?.user_metadata?.af_email_verified !== false;

  const configQuery = useQuery({
    queryKey: ["feedback-config"],
    queryFn: async () => {
      const res = await getFeedbackConfig();
      if ("error" in res) return { trigger1Jobs: 3, trigger2Jobs: 10, rewardCredits: 3, enabled: true };
      return res.data!;
    },
    staleTime: 10 * 60_000,
    enabled: !!user,
  });

  const givenQuery = useQuery({
    queryKey: ["feedback-given", user?.id],
    queryFn: async () => {
      const res = await checkFeedbackGiven();
      if ("error" in res) return { given: true }; // błąd → nie zaczepiaj usera
      return res.data!;
    },
    staleTime: 5 * 60_000,
    enabled: !!user,
  });

  const reward = configQuery.data?.rewardCredits ?? 3;
  const show =
    !!user &&
    !authLoading &&
    emailVerified &&
    configQuery.data?.enabled === true &&
    givenQuery.data?.given === false;

  if (!show) return null;

  return (
    <button
      type="button"
      onClick={onOpen}
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px 10px",
        width: "100%",
        padding: "10px 16px",
        border: "none",
        background: "var(--accent)",
        color: "#fff",
        fontSize: 13,
        fontWeight: 600,
        textAlign: "center",
        cursor: "pointer",
        flexShrink: 0,
      }}
    >
      <Icon name="gift" style={{ width: 16, height: 16, flexShrink: 0 }} />
      <span style={{ lineHeight: 1.35 }}>
        Odbierz <strong style={{ fontWeight: 800 }}>{reward} darmowych kredytów</strong> — podziel się
        opinią (15 sek).
      </span>
      <span
        style={{
          padding: "4px 12px",
          borderRadius: 999,
          background: "rgba(255, 255, 255, 0.18)",
          fontSize: 12,
          fontWeight: 700,
        }}
      >
        Zostaw opinię
      </span>
    </button>
  );
}
